export default __webpack_public_path__ + "0ac62556bbf0e46488e2a2cdd1e78c11.png";